/* eslint-disable*/
/* eslint-disable max-len */
/* eslint-disable indent */
/* eslint-disable react/jsx-indent */
import { get } from 'lodash';
// eslint-disable-next-line object-curly-newline
import { ArrowDownward, ArrowUpward, Check } from '@mui/icons-material';
import { useHistory } from 'react-router-dom';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
// import { ListTable } from '../../../Components/ListTable';
import { classes, convertWeightUnit, getHigherUnitAndQuantity, useProductData } from '../../../Helpers';
import { urls } from '../../../Constants';
import styles from './QualityAnalysisListPage.module.scss';
import analyticsAction from '../../../Actions/analytics.actions';
import { useAuth } from '../../../Components/Auth/Login/auth';
import { VirtualizedListTable } from '@/Components/VirtualizedListTable';
// import { ArrangePages } from '../../../Components/Arrange Pages';

const Modes = {
	PRODUCTION: 'Ai-Inventory-In',
	INWARD: 'Ai-GRN',
	OUTWARD: 'Ai-Inventory-Out',
};

const renderColumn = (column) => {
	switch (column) {
		case 'Validated':
		case 'Identified':
		case 'Features':
			return (
				<div
					style={{
						width: '100%',
						textAlign: 'center',
					}}
				>
					{column?.toUpperCase()}
				</div>
			);
		default:
			return null;
	}
};

const getRowStyles = (item) => {
	switch (item?.result) {
		case 'FAILED':
			return styles.critical;
		case 'SKIPPED':
			return styles.skipped;
		case 'OVERRIDDEN':
			return styles.moderate;
		default:
			return styles.normal;
	}
};

function setAttr(text) {
	return <span className={styles.text}>{text}</span>;
}

const QualityAnalysisListPage = (props) => {
	const history = useHistory();
	const {
		data = [],
		TABLE_COLUMNS = [],
		COLMAP,
	} = props;
	const { appConfig = {} } = useAuth();
	const { measurement } = appConfig?.configs ?? {};
	const products = useSelector((state) => state.form.ALL_PRODUCTS.data.LIST);
	const dispatch = useDispatch();

	useEffect(() => {
		// if (Array.isArray(products) && products?.length === 0) {
		useProductData(dispatch);
		// }
	}, []);

	const SPECIAL_ITEMS = {
		'UY Id': (altProps, item) => {
			return setAttr(item?.id);
		},
		Weight: (altProps, item) => {
			let failure =
				item?.Weight > item?.MaxWeight / 1000 ? 'OVER' : 'UNDER';
			failure =
				item?.WeightCheckRequired && !item?.IsWeightInRange && failure;
			const itemWeight = get(item, COLMAP.Weight, 0);
			let itemUnit = item?.unit;
			if (item?.unit === 'count') {
				if (measurement === 'US') {
					itemUnit = 'oz';
				} else {
					itemUnit = 'gram';
				}
			}
			const [displayValue, displayUnit] = getHigherUnitAndQuantity(itemUnit, itemWeight);
			return (
				<span
					className={`${styles['no-wrap']} ${styles.text} ${failure ? styles.critical : styles.normal
						}`}
				>
					{displayValue ?? '-'}
					{displayUnit}
					{data[altProps - 1]?.IsWeightInRange === false ? (
						<>
							{failure === 'OVER' && <ArrowUpward />}
							{failure === 'UNDER' && <ArrowDownward />}
						</>
					) : (
						<></>
					)}
				</span>
			);
		},
		Count: (altProps) => {
			return setAttr(data[altProps - 1]?.count ?? '-');
		},
		Temp: (altProps, item) => {
			let failure = null;
			item.Temp > item.MaxTemp
				? 'OVER'
				: 'UNDER';

			failure =
				item?.TempCheckRequired &&
				!item?.IsTempInRange &&
				failure;
			return (
				<span
					className={`${styles['no-wrap']} ${styles.text} ${failure ? styles.critical : styles.normal
						}`}
				>
					{String(get(item, COLMAP.Temp)).startsWith('120') ||
						String(get(item, COLMAP.Temp)).startsWith('125')
						? '-'
						: get(item, COLMAP.Temp)?.toFixed(2) ?? '-'}
					{measurement === 'US' ? '°F' : '°C'}
					{item?.IsTempInRange === false ||
						!item?.IsTempInRange ? (
						<>
							{failure && <ArrowUpward />}
							{failure && <ArrowDownward />}
						</>
					) : (
						<></>
					)}
				</span>
			);
		},
		// Brand: (altProps) => {
		// return (
		// <span className={styles['brand-column']}>
		// <img
		// className={styles.logo}
		// src={data[altProps - 1]?.BrandImage}
		// alt='Brand'
		// />
		// <p>{data[altProps - 1]?.brandName}</p>
		// </span>
		// );
		// },
		Store: (altProps, item) => {
			return (
				<span className={styles['brand-column']}>
					<p>{item?.storeName ?? '-'}</p>
				</span>
			);
		},
		'QC TIME': (altProps, item) => {
			return setAttr(get(item, COLMAP['QC TIME']));
		},
		'Product Name': (altProps, item) => {
			return setAttr(get(item, COLMAP['Product Name']));
		},
		Category: (altProps, item) => {
			return products?.find((product) => Number(product?.id) === Number(item?.productId))?.categoryName;
		},
		'Sub Category': (altProps, item) => {
			return products?.find((product) => Number(product?.id) === Number(item?.productId))?.subCategoryName;
		},
		'Sku Code': (altProps, item) => {
			return products?.find((product) => Number(product?.id) === Number(item?.productId))?.variants?.find((variant) => Number(variant?.id) === Number(item?.variantId))?.clientVariantId;
		},
		'Inventory Type': (altProps, item) => {
			return setAttr(get(item, COLMAP['Inventory Type']));
		},
		'Order Id': (altProps, item) => {
			const text = get(item, COLMAP['Order Id']);
			// eslint-disable-next-line prefer-template
			return setAttr(
				text ? `${text.substring(0, 6)}...` : '-'
			);
		},
		// 'Item Id': (altProps) => {
		// return setAttr(get(data[altProps - 1], COLMAP['Item Id']));
		// },
		Validated: (altProps, item) => {
			const validated = get(item, COLMAP.Validated);

			if (validated) {
				return <Check />;
			}
			return null;
		},
		Identified: (altProps, item) => {
			const identification = get(item, [
				COLMAP.Identified,
				'0',
			]);

			let identified = false;

			if (
				identification?.x != null &&
				identification?.y != null &&
				identification?.width != null &&
				identification?.height != null
			) {
				identified = true;
			}

			if (identified) {
				return <Check />;
			}
			return null;
		},
		Features: (altProps, item) => {
			const annotated = get(item, COLMAP.Features);
			return annotated;
		},
	};

	return (
		<div className={classes(styles.root, 'list-page-root')}>
			<VirtualizedListTable
				fixedHeaderTop={0}
				hasDateRange
				renderColumn={renderColumn}
				colMap={COLMAP}
				special={SPECIAL_ITEMS}
				data={data.map((obj, idx) => {
					const rowStyles = getRowStyles(obj);
					// const itemId = get(obj, COLMAP['Item Id']);
					const itemId = obj?.itemId;
					// const qc = get(obj, COLMAP.qc);
					const qc = obj?.id;
					return {
						...obj,
						id: idx + 1,
						rowStyles,
						onClick: () => {
							history.push({
								pathname: `${urls.EXTENSION}${urls.PAST_QC}/${itemId}`,
								search: `id=${qc}`,
								state: {
									from: history?.location?.pathname,
									search: history?.location?.search,
								},
							});
						},
					};
				})}
				// data={data}
				columns={TABLE_COLUMNS}
				allowExport={false}
			/>
			{/* <ArrangePages
				listCount={61}
				ANALYTICS_TYPE={ANALYTICS_TYPE}
				setAnalyticsType={setAnalyticsType}
			/> */}
		</div>
	);
};

const mapStateToProps = () => {
	return {};
};
const mapDispatchToProps = {
	setAnalyticsType: analyticsAction.setAnalyticsType,
};
export default connect(
	mapStateToProps,
	mapDispatchToProps
)(QualityAnalysisListPage);
